import script from "./SelectOption.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOption.vue?vue&type=script&setup=true&lang=js"

import "./SelectOption.vue?vue&type=style&index=0&id=3b6aea4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6aea4e"]])

export default __exports__